import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { InviteUserDialog } from "@/components/users/InviteUserDialog";
import { UserListTable } from "@/components/users/UserListTable";
import { InactiveUsersTable } from "@/components/users/InactiveUsersTable";
import { PendingInvitesTable } from "@/components/users/PendingInvitesTable";
import { BetaCodesTab } from "@/components/settings/BetaCodesTab";
import { Users as UsersIcon, Mail, Ticket, UserX } from "lucide-react";

export default function Users() {
  return (
    <div className="flex flex-col min-h-screen">
      <header className="sticky top-0 z-10 flex h-16 items-center gap-4 border-b bg-card px-6">
        <SidebarTrigger />
        <div className="flex-1">
          <h1 className="text-lg font-semibold text-foreground">Users</h1>
        </div>
        <InviteUserDialog />
      </header>

      <div className="flex-1 p-6">
        <Tabs defaultValue="users" className="w-full space-y-6">
          <TabsList className="grid w-full max-w-3xl grid-cols-4">
            <TabsTrigger value="users" className="flex items-center gap-2">
              <UsersIcon className="h-4 w-4" />
              Active Users
            </TabsTrigger>
            <TabsTrigger value="inactive" className="flex items-center gap-2">
              <UserX className="h-4 w-4" />
              Inactive
            </TabsTrigger>
            <TabsTrigger value="invites" className="flex items-center gap-2">
              <Mail className="h-4 w-4" />
              Invites
            </TabsTrigger>
            <TabsTrigger value="access-codes" className="flex items-center gap-2">
              <Ticket className="h-4 w-4" />
              Codes
            </TabsTrigger>
          </TabsList>

          <TabsContent value="users">
            <div className="border rounded-lg bg-card">
              <UserListTable />
            </div>
          </TabsContent>

          <TabsContent value="inactive">
            <div className="border rounded-lg bg-card">
              <InactiveUsersTable />
            </div>
          </TabsContent>

          <TabsContent value="invites">
            <div className="border rounded-lg bg-card">
              <PendingInvitesTable />
            </div>
          </TabsContent>

          <TabsContent value="access-codes">
            <BetaCodesTab />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
